import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class GoogleApiKeyService {
  private readonly webApiKey = 'AIzaSyBhUQicmoPznmQhp7NwC7pUzW6wOu3edQo';
  private readonly appApiKey = 'AIzaSyDX8co0kvPufyqJvaTCYN0ge4PTCAtjrAk';

  getApiKey(): string {
    return Capacitor.isNativePlatform() ? this.appApiKey : this.webApiKey;
  }
}
